import React from 'react';
import { useTechnologiesData } from './context/TechnologiesContext';
import pb from './lib/pocketbase';
import './App.css';

export default function TechnologiesPage() {
    const { technologies, loading } = useTechnologiesData();

    const categories = ['Frontend', 'Backend', 'Data & Infra'];

    if (loading) {
        return <div className="loading-container">Chargement de notre stack...</div>;
    }

    return (
        <div className="technologies-page">
            <section className="tech-hero">
                <div className="hero-content">
                    <h1>Notre Stack Technique</h1>
                    <p>Nous maîtrisons les technologies les plus robustes pour garantir pérennité et performance.</p>
                </div>
            </section>

            <div className="tech-container">
                {categories.map(cat => {
                    const catTechs = technologies.filter(t => t.category === cat && t.is_active !== false);
                    if (catTechs.length === 0) return null;

                    return (
                        <section key={cat} className="tech-category-section">
                            <h2 className="tech-cat-title">{cat}</h2>
                            <div className="bento-grid">
                                {catTechs.map((tech, index) => (
                                    <div
                                        key={tech.id}
                                        className={`bento-item ${index % 5 === 0 ? 'large' : ''}`}
                                    >
                                        <div className="bento-inner glass-card">
                                            <div className="tech-logo-wrapper">
                                                {tech.logo ? (
                                                    <img src={pb.files.getUrl(tech, tech.logo)} alt={tech.name} />
                                                ) : (
                                                    <span className="tech-placeholder">{tech.name.charAt(0)}</span>
                                                )}
                                            </div>
                                            <h3>{tech.name}</h3>
                                            <p>{tech.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    );
                })}
            </div>
        </div>
    );
}
